'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Immutable = require('Immutable');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TimezoneGroups = function () {
  function TimezoneGroups(val) {
    _classCallCheck(this, TimezoneGroups);

    this.groups = (0, _Immutable.List)(val);
  }

  _createClass(TimezoneGroups, [{
    key: 'groupForMomentTimezone',
    value: function groupForMomentTimezone(timezone) {
      return this.groups.find(function (g) {
        return g.timezones.some(function (tz) {
          return tz.momentTimezones.includes(timezone);
        });
      });
    }
  }, {
    key: 'resolve',
    value: function resolve(timezone, defaultTz) {
      var groupForTimezone = this.groupForMomentTimezone(timezone);
      if (groupForTimezone === undefined) {
        groupForTimezone = this.groupForMomentTimezone(defaultTz);
        timezone = defaultTz;
      }
      return groupForTimezone.timezoneForMomentTimezone(timezone).identifier();
    }
  }]);

  return TimezoneGroups;
}();

exports.default = TimezoneGroups;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/timezone-utils/static-2.97/js/lists/TimezoneGroups.js
// module id = 467
// module chunks = 0